import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setObjPortal } from "../features/portalSlice";
import { useUtilityContext } from "../utility-provider";
import { useUserContext } from "../user-provider";
import {
    portalTypeList,
    dataTypeList,
    findLatestBranch,
    dataOptimization,
    columns,
} from './subPage/Portal/PortalFunction';

import {
    Box,
    Dialog,
    DialogTitle,
    Grid,
    List,
    ListItem,
    ListItemButton,
    styled,
} from "@mui/material";
import {
    DataGrid,
    GridRowsProp,
    GridToolbarContainer,
    GridToolbarExport,
    GridRowParams,
} from "@mui/x-data-grid";
import { getPortalSummaryList } from "../../src/data/DataManage";
import MailCreateModal from "./components/MailCreateModal";
import ResearchBranchModal from "./components/ResearchBranchModal";
import GisImportModal from "./components/GisImportModal";
import dayjs from "dayjs";
import { LOCAL_CONSTANT } from "./Const";
import AccordionMenu from "../page/subPage/Portal/AccordionMenu";
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { GridSortModel } from '@mui/x-data-grid';
import { encryptQueryParam } from "../utility/util";

interface ListItemProps {
    props: {
        width: number;
        height: number;
    };
}

//「ステータス」プルダウンリスト用オブジェクト
let statusList: any[] = [];
//「依頼担当」プルダウンリスト用オブジェクト
let picTypeList: any[] = [];
//「依頼タスク」プルダウンリスト用オブジェクト
let requestTaskList: any[] = [];
//「依頼担当者」プルダウンリスト用オブジェクト
let picNameList: any[] = [];
//「部」プルダウンリスト用オブジェクト
let departmentList: any[] = [];
//「地区」プルダウンリスト用オブジェクト
let districtList: any[] = [];
//「候補地No」プルダウンリスト用オブジェクト
let planAreaIdList: any[] = [];
// 「RFC」プルダウンリスト用オブジェクト
let planAreaRfcList: any[] = [];
//テーブル表示用オブジェクト
let listDataContent: GridRowsProp = [];

//テーブルカスタムツールバー
const costomToolBar = () => {
    return (
        <GridToolbarContainer>
            <GridToolbarExport
                csvOptions={{
                    delimiter: ",",
                    utf8WithBom: true,
                }}
                printOptions={{
                    disableToolbarButton: true
                }}
            />
        </GridToolbarContainer>
    );
};

//スタイル
const ModalButton = styled(ListItemButton)({
    backgroundColor: "#FFFFFF",
    color: "#0E6F55",
    border: "1px solid #00AC4C",
});
const styles = {
    dataGrid: {
        ".MuiDataGrid-toolbarContainer": {
            borderBottom: "solid 1px rgba(224, 224, 224, 1)",
            display: "block",
        },
        ".MuiDataGrid-row .MuiDataGrid-cell:not(:last-child)": {
            borderRight: "solid 1px rgba(224, 224, 224, 1) !important",
        },
        ".MuiDataGrid-columnHeaders": {
            backgroundColor: "#00CC5B",
            color: "#fff",
        },
        ".MuiDataGrid-columnHeader": {
            border: "solid 1px rgba(224, 224, 224, 1)",
        },
        ".MuiDataGrid-virtualScrollerContent": {
            backgroundColor: "white",
        },
        ".MuiButtonBase-root": {
            float: "right",
        },
        "& .active-elapsed-row": {
            backgroundColor: "#f9d2d878",
        },
    },
    modalStyle: {
        ".MuiPaper-root": {
            width: "100%",
        },
    },
    disabledTextField: {
        ".MuiFormControl-root": {
            width: "100%",
        },
        ".MuiInputBase-root": {
            backgroundColor: "#7b7b7b5c",
        },
    },
};

type CustomFooterProps = {
    rowCount: number;
    page: number;
    pageSize: number;
    onPageChange: (newPage: string) => void;
    dataGridLoading: boolean;
};

function CustomFooter({
    rowCount,
    page,
    pageSize,
    onPageChange,
    dataGridLoading, // ボタン活性制御用
}: CustomFooterProps) {
    const start = page * pageSize + 1;
    const end = Math.min((page + 1) * pageSize, rowCount);

    return (
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '8px 16px',
        borderTop: '1px solid #e0e0e0',
        background: '#fafafa'
        }}>
            <div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    onClick={() => onPageChange("before")}
                    disabled={page <= 0 || dataGridLoading}
                    size="small"
                >
                    <ChevronLeftIcon />
                </IconButton>
                <span style={{ margin: '0 8px' }}>{start}-{end}件 / 全{rowCount}件中</span>
                <IconButton
                    onClick={() => onPageChange("after")}
                    disabled={end >= rowCount || dataGridLoading}
                    size="small"
                >
                    <ChevronRightIcon />
                </IconButton>
            </div>
        </div>
    );
}

const SecondaryListItems: React.FC<ListItemProps> = ({ props }) => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    //データグリッドローディングフラグ
    const [dataGridLoading, setDataGridLoading] = useState(false);
    //ポータルオブジェクト
    const objPortal = useAppSelector((state) => state.portal);
    //モーダル開閉フラグ(テーブルレコード)
    const [tableModalOpen, setTableModalOpen] = useState(false);
    //モーダル開閉フラグ(調査書枝選択画面)
    const [researchBranchOpen, setResearchBranchOpen] = useState(false);
    //モーダル開閉フラグ(メール作成画面)
    const [mailModalOpen, setMailModalOpen] = useState(false);
    //モーダル開閉フラグ(GIS取込)
    const [gisImportModalOpen, setGisImportModalOpen] = useState(false);
    //検索パラメータ用(依頼受付日)
    const [conversionCreateDate, setConversionCreateDate] =
        useState<string>("");
    //検索パラメータ用(候補地No)
    const [planAreaId, setPlanAreaId] = useState<string>("");
    //検索パラメータ用(候補地名)
    const [planAreaName, setPlanAreaName] = useState<string>("");
    //検索パラメータ用(ステータス)
    const [statusId, setStatusId] = useState<string[]>([]);
    //検索パラメータ用(部)
    const [departmentCode, setDepartmentCode] = useState<string[]>([]);
    //検索パラメータ用(担当依頼)
    const [picType, setPicType] = useState<string[]>([]);
    //検索パラメータ用(地区)
    const [districtCode, setDistrictCode] = useState<string[]>([]);
    //検索パラメータ用(依頼担当者)
    const [picStaffNumber, setPicStaffNumber] = useState<string[]>([]);
    //検索パラメータ用(依頼タスク)
    const [taskId, setTaskId] = useState<string[]>([]);
    //テーブル表示用オブジェクト
    const [rows, setRows] = useState(listDataContent);
    //調査書画面遷移時パラメータ(候補地No)
    const [selectPlanAreaId, setSelectPlanAreaId] = useState("");

    //調査書画面遷移時パラメータ(枝)
    const [selectBranch, setSelectBranch] = useState("");
    //全レコード保持用オブジェクト
    const [allDataObj, setAllDataObj] = useState<portalTypeList[]>();
    //調査書枝選択モーダル用オブジェクト
    const [selectDataObj, setSelectDataObj] = useState<portalTypeList[]>();
    //メール作成モーダル用オブジェクト
    const [selectMailObj, setSelectMailObj] = useState<dataTypeList>();
    //value格納用(ステータス)
    const [statusValueList, setStatusValueList] = useState<any[]>([]);
    //value格納用(依頼担当)
    const [picTypeValueList, setPicTypeValueList] = useState<any[]>([]);
    //value格納用(依頼タスク)
    const [taskValueList, setTaskValueList] = useState<any[]>([]);
    //value格納用(依頼担当者)
    const [picNameValueList, setPicNameValueList] = useState<any[]>([]);
    //value格納用(地区)
    const [districtValueList, setDistrictValueList] = useState<any[]>([]);
    //value格納用(部)
    const [departmentValueList, setDepartmentValueList] = useState<any[]>([]);
    //value格納用(RFC)
    const [rfcValueList, setRfcValueList] = useState<any[]>([]);
    //バッチローディングフラグ
    const [batchLoadingFlag, setBatchLoadingFlag] = useState(false);
    //ログインユーザータイプ
    const [userType, setUserType] = useState<string>("");
    //ログインユーザーID
    const [userId, setUserId] = useState<string>("");
    //部署名(RFC、RM、GM)
    const [departmentName, setDepartmentName] = useState<string>("");
    //地区名(RFC、RM)
    const [districtName, setDistrictName] = useState<string>("");
    //検索非活性フラグ
    const [disabledSearch, setDisabledSearch] = useState(true);
    // カウント用
    const [countTimer, setCountTimer] = useState<number>(60)
    // 開始カーソルデータ（初期はブランク）
    const [startCursor, setStartCursor] = useState("");
    // 終了カーソルデータ（初期はブランク）
    const [endCursor, setEndCursor] = useState("");
    // 開始カーソルデータ自動検索用（初期はブランク）
    const [startCursorAuto, setStartCursorAuto] = useState("");
    // 終了カーソルデータ自動検索用（初期はブランク）
    const [endCursorAuto, setEndCursorAuto] = useState("");
    // 取得件数
    const [inputValue, setInputValue] = useState<number>(0);
    // 全体件数（初期は0）
    const [total, setTotal] = useState<number>(0);
    // フッターフラグ
    const [showFooter, setShowFooter] = useState<boolean>(false); // 初期値は非表示
    // 現在ページ
    const [currentPage, setCurrentPage] = useState(0);
    // 現在モード（最終検索が次へか前へかの情報）
    const [mode, setMode] = useState("");
    // ページサイズ（デフォルトは100で現時点では固定）
    const pageSize = 100; // 固定
    const [sortModel, setSortModel] = useState<GridSortModel>([]);

    // 計測カウントダウン
    useEffect(() => {
        const countDownInterval = setInterval(() => {
            if (batchLoadingFlag) {
                if (countTimer === 1) {
                    clearInterval(countDownInterval)
                    setBatchLoadingFlag(false);
                    batchSearch()
                } else if (countTimer && countTimer > 1) {
                    setCountTimer(countTimer - 1)
                }
            } else {
                clearInterval(countDownInterval)
            }
        }, 1000)
        return () => {
            clearInterval(countDownInterval)
        }
    }, [countTimer, batchLoadingFlag])

    //テーブル表示列管理用ステート
    const [visibleColumns, setVisibleColumns] = useState(
        columns.map((col) => col.field)
    );

    //モーダルオープン(テーブルレコード押下時)
    const handleTableModalOpen = (selectionModel: any) => {
        const resultObj: portalTypeList[] = [];
        let selectRowPlanAreaId: string = "";
        //押下したレコードの候補地No、枝、RFC、RMセット
        rows.map((elem) => {
            if (elem.id === String(selectionModel)) {
                selectRowPlanAreaId = elem.plan_area_id;
                setSelectMailObj(elem as dataTypeList);
                setSelectPlanAreaId(elem.plan_area_id);
                setSelectBranch(elem.branch);
            }
        });
        //全データから押下した候補地Noの全枝番を取得
        if (typeof allDataObj !== "undefined") {
            allDataObj.map((elem) => {
                if (elem.plan_area_id === selectRowPlanAreaId) {
                    resultObj.push(elem);
                }
            });
        }
        setSelectDataObj(resultObj);
        // RFCの場合 モーダル部分(調査書枝選択画面)を開く
        if (userType === LOCAL_CONSTANT.USER_TYPE.RFC) {
            setResearchBranchOpen(true);
        } else {
            // モーダル部分(テーブルレコード)を開く
            setTableModalOpen(true);
        }
    };

    //モーダルクローズ(テーブルレコード)
    const handleTableModalClose = () => {
        setTableModalOpen(false);
    };

    //モーダルオープン(調査書枝選択画面)
    const handleResearchBranchOpen = () => {
        setResearchBranchOpen(true);
    };

    //モーダルオープン(メール作成画面)
    const handleMailModalOpen = () => {
        setMailModalOpen(true);
    };

    //モーダルオープン(GIS取込)
    const handleGisImportModalOpen = () => {
        setGisImportModalOpen(true);
    };

    const closeGisImportModal = () => {
        setGisImportModalOpen(false);
    };

    //プルダウンの検索値パラメータ設定
    const setSearchParams = (dataList: any[]) => {
        let tmpValue: string[] = [];
        dataList.map((e: any) => {
            tmpValue.push(e.value);
        });

        return tmpValue
    };

    //自動検索処理
    const batchSearch = () => {
        //自動検索フラグがfalseの場合は処理しない
        if (!batchLoadingFlag) {
            return;
        }
        //ポータル画面以外処理しない
        if (location.pathname !== "/") {
            setBatchLoadingFlag(false);
            return;
        }
        //検索API呼び出し
        try {
            // 自動検索リクエスト
            timeConsole('自動検索処理 開始')
            const field = sortModel[0]?.field ?? "plan_area_id";
            const sort = sortModel[0]?.sort ?? "desc";
            callApi("batchGetReceptionBook",mode,field,sort)
                .then((res: any) => {
                    setShowFooter(true);
                    setStartCursor(res.pageInfo.startCursor);
                    setEndCursor(res.pageInfo.endCursor);
                    type Edge = { node: any; cursor: string };
                    const list = res.edges.map((edge: Edge) => edge.node);
                    // 全データ登録
                    setAllDataObj(list);
                    //テーブル表示用オブジェクト登録
                    const dataObj = findLatestBranch(list);
                    //テーブル表示用オブジェクト表示用へ変更
                    const dataPicTypeChangeObj = dataOptimization(dataObj, picTypeList);
                    setRows(dataPicTypeChangeObj);
                    setDataGridLoading(false);
                    //自動検索処理フラグ更新
                    setCountTimer(60)
                    setBatchLoadingFlag(true);
                    // 取得件数
                    setInputValue(dataObj.length);
                    // 全体件数（初期は0）
                    setTotal(res.pageInfo.maxSize);
                    timeConsole('自動検索処理 終了')
                })
                .catch((e) => {
                    console.log(e);
                });
        } catch (e) {
            console.log(e);
        }
    };

    //手動検索処理
    const handleSerch = (
        val: string,
        field: string,
        sort: string
    ) => {
        setStartCursor("");
        setEndCursor("");
        setDataGridLoading(true);
        // 手動検索処理開始時は自動検索を停止
        setBatchLoadingFlag(false);
        // インプットデータをReduxへ格納
        dispatch(
            setObjPortal({
                ...objPortal,
                ["conversionCreateDate"]: conversionCreateDate,
                ["statusId"]: statusId,
                ["picType"]: picType,
                ["picStaffNumber"]: picStaffNumber,
                ["taskId"]: taskId,
                ["planAreaId"]: planAreaId,
                ["departmentCode"]: departmentCode,
                ["districtCode"]: districtCode,
                ["planAreaName"]: planAreaName,
                ["planAreaRfc"]: rfcValueList,
                ["statusValues"]: statusValueList,
                ["picTypeValues"]: picTypeValueList,
                ["taskValues"]: taskValueList,
                ["picNameValues"]: picNameValueList,
                ["districtValues"]: districtValueList,
                ["departmentValues"]: departmentValueList,
            })
        );
        //検索API呼び出し
        try {
            timeConsole('検索処理 開始')
            callApi("searchGetReceptionBook",val,field,sort)
                .then((res: any) => {
                    if (val === "first") {
                        setCurrentPage(0);
                    }
                    setMode(val);
                    setShowFooter(true);
                    // 開始カーソルデータ自動検索用
                    setStartCursorAuto(startCursor);
                    // 終了カーソルデータ自動検索用
                    setEndCursorAuto(endCursor);
                    // 開始カーソルデータ
                    setStartCursor(res.pageInfo.startCursor);
                    // 終了カーソルデータ
                    setEndCursor(res.pageInfo.endCursor);
                    type Edge = { node: any; cursor: string };
                    const list = res.edges.map((edge: Edge) => edge.node);
                    // 全データ登録
                    setAllDataObj(list);
                    //テーブル表示用オブジェクト登録
                    const dataObj = findLatestBranch(list);
                    //テーブル表示用オブジェクト表示用へ変更
                    const dataPicTypeChangeObj = dataOptimization(dataObj, picTypeList);
                    setRows(dataPicTypeChangeObj);
                    setDataGridLoading(false);
                    //自動検索処理フラグ更新
                    setCountTimer(60)
                    setBatchLoadingFlag(true);
                    // 取得件数
                    setInputValue(dataObj.length);
                    // 全体件数（初期は0）
                    setTotal(res.pageInfo.maxSize);
                    timeConsole('検索処理 終了')
                })
                .catch((e) => {
                    console.log(e);
                });
        } catch (e) {
            console.log(e);
        }
    };

    const timeConsole = (val: string) => {
        let date = new Date();
        console.log(`${val} ${dayjs(date).format('YYYY-MM-DD HH:mm:ss')}`)
    }

    //API呼び出し
    const callApi = async (target: string, mode: string, field: string, sort: string) => {
        //テーブル表示用データ取得(自動検索)
        const params: any = {
            mode: "",
            rfc_request_date: null,
            status_id: null,
            pic_type: null,
            pic_staff_number: null,
            task_id: null,
            plan_area_id: null,
            department_code: null,
            district_code: null,
            plan_area_name: null,
            plan_area_rfc: null,
            login_user_id: userId,
            userType: userType,
            first: null,
            after: null,
            last: null,
            before: null,
            field: field,
            sort: sort
        }
        //テーブル表示用データ取得(自動検索)
        if (target === "batchGetReceptionBook") {
            if (mode === "first") {
                params.mode = "getPortalSummaryListConnectionAfter"
                params.first = pageSize
                params.after = ""
            } else if (mode === "after") {
                params.mode = "getPortalSummaryListConnectionAfter"
                params.first = pageSize
                params.after = endCursorAuto
            } else if (mode === "before") {
                params.mode = "getPortalSummaryListConnectionBefore"
                params.last = pageSize
                params.before = startCursorAuto
            }
            // 地区、部の編集可、不可でパラメータの検索値を変更
            let tmpDepartmentCode = departmentCode;
            let tmpDistrictCode = districtCode;
            if ( // リサーチ、その他ユーザーの場合
                userType === LOCAL_CONSTANT.USER_TYPE.RR ||
                userType === LOCAL_CONSTANT.USER_TYPE.OTHER
            ) {
                tmpDepartmentCode = setSearchParams(objPortal["departmentValues"]);
                tmpDistrictCode = setSearchParams(objPortal["districtValues"]);
            } else if ( // GMの場合
                userType === LOCAL_CONSTANT.USER_TYPE.GM
            ) {
                tmpDistrictCode = setSearchParams(objPortal["districtValues"]);
            }
            params.rfc_request_date = objPortal["conversionCreateDate"]
            params.status_id = setSearchParams(objPortal["statusValues"])
            params.pic_type = setSearchParams(objPortal["picTypeValues"])
            params.pic_staff_number = setSearchParams(objPortal["picNameValues"])
            params.task_id = setSearchParams(objPortal["taskValues"])
            params.plan_area_id = objPortal["planAreaId"]
            params.department_code = tmpDepartmentCode
            params.district_code = tmpDistrictCode
            params.plan_area_name = objPortal["planAreaName"]
            params.plan_area_rfc = setSearchParams(objPortal["planAreaRfc"])
        }
        //テーブル表示用データ取得(手動検索)
        if (target === "searchGetReceptionBook") {
            if (mode === "first") {
                params.mode = "getPortalSummaryListConnectionAfter"
                params.first = pageSize
                params.after = ""
            } else if (mode === "after") {
                params.mode = "getPortalSummaryListConnectionAfter"
                params.first = pageSize
                params.after = endCursor
            } else if (mode === "before") {
                params.mode = "getPortalSummaryListConnectionBefore"
                params.last = pageSize
                params.before = startCursor
            }
            // 地区、部の編集可、不可でパラメータの検索値を変更
            let tmpDepartmentCode = departmentCode;
            let tmpDistrictCode = districtCode;
            if ( // リサーチ、その他ユーザーの場合
                userType === LOCAL_CONSTANT.USER_TYPE.RR ||
                userType === LOCAL_CONSTANT.USER_TYPE.OTHER
            ) {
                tmpDepartmentCode = setSearchParams(departmentValueList);
                tmpDistrictCode = setSearchParams(districtValueList);
            } else if ( // GMの場合
                userType === LOCAL_CONSTANT.USER_TYPE.GM
            ) {
                tmpDistrictCode = setSearchParams(districtValueList);
            }
            params.rfc_request_date = conversionCreateDate
            params.status_id = setSearchParams(statusValueList)
            params.pic_type = setSearchParams(picTypeValueList)
            params.pic_staff_number = setSearchParams(picNameValueList)
            params.task_id = setSearchParams(taskValueList)
            params.plan_area_id = planAreaId
            params.department_code = tmpDepartmentCode
            params.district_code = tmpDistrictCode
            params.plan_area_name = planAreaName
            params.plan_area_rfc = setSearchParams(rfcValueList)
        }
        return await getPortalSummaryList(params);
    };

    //localstorageからプルダウン値取得
    const setPullDownList = () => {
        const codeMasterObj = localStorage.getItem("codeMaster");
        let checkCodeMaster = false;
        let checkStaffMater = false;
        let checkDeparment = false;
        let checkPlanArea = false;
        if (codeMasterObj !== null) {
            const jsonCodeMasterObj = JSON.parse(codeMasterObj);
            const statusNames = jsonCodeMasterObj.status_name;
            statusNames.map((e: any) => {
                if (!statusList.some((t) => t.value === e.code_value)) {
                    statusList.push({
                        label: e.code_display,
                        value: e.code_value,
                    });
                }
            });
            const picTypes = jsonCodeMasterObj.pic_type;
            picTypes.map((e: any) => {
                if (!picTypeList.some((t) => t.value === e.code_value)) {
                    picTypeList.push({
                        label: e.code_display,
                        value: e.code_value,
                    });
                }
            });
            const taskNames = jsonCodeMasterObj.task_name_id;
            taskNames.map((e: any) => {
                if (!requestTaskList.some((t) => t.value === e.code_value)) {
                    requestTaskList.push({
                        label: e.code_display,
                        value: e.code_value,
                    });
                }
            });
            checkCodeMaster = true;
        }
        const staffMasterObj = localStorage.getItem("staffMaster");
        if (staffMasterObj !== null) {
            const jsonStaffMasterObj = JSON.parse(staffMasterObj);
            jsonStaffMasterObj.map((e: any) => {
                if (!picNameList.some((t) => t.value === e.staff_number)) {
                    picNameList.push({
                        label: e.staff_name,
                        value: e.staff_number,
                    });
                }
                if (
                    !planAreaRfcList.some((t) => t.value === e.staff_number) &&
                    e.job_category_code_oa === "360"
                ) {
                    planAreaRfcList.push({
                        label: e.staff_name,
                        value: e.staff_number,
                    });
                }
            });
            checkStaffMater = true;
        }
        const departmentMasterObj = localStorage.getItem("departmentMaster");
        if (departmentMasterObj !== null) {
            const jsonDepartmentMasterObj = JSON.parse(departmentMasterObj);
            jsonDepartmentMasterObj.map((e: any) => {
                if (
                    !departmentList.some(
                        (t) => t.value === e.department_code_oa
                    )
                ) {
                    departmentList.push({
                        label: e.department_name_oa,
                        value: e.department_code_oa,
                    });
                }
                if (!districtList.some((t) => t.value === e.district_code_oa)) {
                    districtList.push({
                        label: e.district_name_oa,
                        value: e.district_code_oa,
                    });
                }
            });
            checkDeparment = true;
        }
        const planAreaListObj = localStorage.getItem("planAreaList");
        if (planAreaListObj !== null) {
            const jsonPlanAreaListObj = JSON.parse(planAreaListObj);
            jsonPlanAreaListObj.map((e: any) => {
                if (!planAreaIdList.includes(e.id)) {
                    planAreaIdList.push(e.id);
                }
            });
            checkPlanArea = true;
        }
        //全てのプルダウンがセット出来たら検索ボタン活性化
        if (
            checkCodeMaster &&
            checkStaffMater &&
            checkDeparment &&
            checkPlanArea
        ) {
            setDisabledSearch(false);
        }
    };

    //localStorage更新毎実行関数
    useEffect(() => {
        //各検索欄プルダウンセット
        setPullDownList();
        //ユーザー別ハンドリング
        setUserInfo();
    }, [objPortal.localStorageFlag]);


    useEffect(() => {
        //localstorageからプルダウン値セット
        setPullDownList();
    }, []);

    //ユーザー別ハンドリング関数
    const setUserInfo = () => {
        let userDepartmentValue: string[] = [];
        let userDistrictValue: string[] = [];
        if (JSON.parse(user.userData || "null") !== null) {
            const userData = JSON.parse(user.userData || "null");
            setUserType(userData?.user_type ?? "");
            setUserId(userData?.staff_number ?? "");
            //GMの場合
            if (userData?.user_type === LOCAL_CONSTANT.USER_TYPE.GM) {
                userDepartmentValue.push(userData?.department_code_OA);
                setDepartmentCode(userDepartmentValue);
                departmentList.map((e: any) => {
                    if (e.value === userData?.department_code_OA) {
                        setDepartmentName(e.label);
                    }
                });
                setRfcValueList([]);
            //RFC or RMの場合
            } else if (
                userData?.user_type === LOCAL_CONSTANT.USER_TYPE.RM ||
                userData?.user_type === LOCAL_CONSTANT.USER_TYPE.RFC
            ) {
                userDepartmentValue.push(userData?.top_department_code_OA);
                userDistrictValue.push(userData?.department_code_OA);
                setDepartmentCode(userDepartmentValue);
                setDistrictCode(userDistrictValue);
                departmentList.map((e: any) => {
                    if (e.value === userData?.top_department_code_OA) {
                        setDepartmentName(e.label);
                    }
                });
                districtList.map((e: any) => {
                    if (e.value === userData?.department_code_OA) {
                        setDistrictName(e.label);
                    }
                });
                //RFCの場合RFC項目の初期値をログインユーザーに設定
                if(userData?.user_type === LOCAL_CONSTANT.USER_TYPE.RFC) {
                    let rfcValueObj = {};
                    let userRfcValue = [];
                    planAreaRfcList.map((e:any) => {
                        if(e.value === userData?.staff_number) {
                            rfcValueObj = {label: e.label, value: userData?.staff_number};
                        }
                    });
                    userRfcValue.push(rfcValueObj);
                    setRfcValueList(userRfcValue);
                } else {
                    setRfcValueList([]);
                }
            //リクルートリサーチ or その他職種の場合
            } else if (
                userData?.user_type === LOCAL_CONSTANT.USER_TYPE.RR ||
                userData?.user_type === LOCAL_CONSTANT.USER_TYPE.OTHER
            ) {
                setDepartmentCode([]);
                setDistrictCode([]);
                setRfcValueList([]);
            }
            //テーブルオブジェクトの設定
            let newVisibleColumns = columns.map((col) => col.field);

            //リサーチでない場合 非表示カラムを設定
            if (userData?.user_type !== LOCAL_CONSTANT.USER_TYPE.RR) {
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "task_change_date"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "elapsedTime"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "type"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "assembly"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "branch"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "pic_name"
                );
            }
            //リサーチの場合 非表示カラムを設定
            if (userData?.user_type === LOCAL_CONSTANT.USER_TYPE.RR) {
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "daily_sales_year_2"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "daily_sales_year_3"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "daily_sales_year_4"
                );
                newVisibleColumns = newVisibleColumns.filter(
                    (col) => col !== "daily_sales_year_5"
                );
            }
            setVisibleColumns(newVisibleColumns);
        }
    };

    //ユーザー取得タイミングによる画面制御
    useEffect(() => {
        //ユーザー別ハンドリング
        setUserInfo();
    }, [user]);

    //画面遷移処理
    const handlePageMove = (page: string) => {
        const param = `?planAreaId=${selectPlanAreaId}&branch=${selectBranch}`;
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        // URLパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            const url = `${page}?` + res;
            window.open(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    const handleMethod = (params: any) => {
        switch (params.target) {
            case "handleSerch":
                handleSerch("first", sortModel[0]?.field ?? "plan_area_id", sortModel[0]?.sort ?? "desc");
                break;
            case "handleSerchAfter":
                handleSerch("after", sortModel[0]?.field ?? "plan_area_id", sortModel[0]?.sort ?? "desc");
                break;
            case "handleSerchBefore":
                handleSerch("before", sortModel[0]?.field ?? "plan_area_id", sortModel[0]?.sort ?? "desc");
                break;
            case "handleGisImportModalOpen":
                handleGisImportModalOpen()
                break;
            case "setConversionCreateDate":
                setConversionCreateDate(params.value)
                break;
            case "setPlanAreaName":
                setPlanAreaName(params.value)
                break;
            case "setStatusValueList":
                setStatusValueList(params.value)
                break;
            case "setPicTypeValueList":
                setPicTypeValueList(params.value)
                break;
            case "setTaskValueList":
                setTaskValueList(params.value)
                break;
            case "setPicNameValueList":
                setPicNameValueList(params.value)
                break;
            case "setDistrictValueList":
                setDistrictValueList(params.value)
                break;
            case "setDepartmentValueList":
                setDepartmentValueList(params.value)
                break;
            case "setRfcValueList":
                setRfcValueList(params.value)
                break;
            case "setPlanAreaId":
                setPlanAreaId(params.value)
                break;
        }
    }

    const handlePageChange = async (newPage:any) => {
        // APIリクエスト（例：ページごとのデータ取得）
        try {
            
            if (newPage === "after") {
                // 「次へ」ボタンの処理
                handleSerch("after", sortModel[0]?.field ?? "plan_area_id", sortModel[0]?.sort ?? "desc");
                setCurrentPage((prev) => prev + 1);
            } else if (newPage === "before") {
                // 「前へ」ボタンの処理
                handleSerch("before", sortModel[0]?.field ?? "plan_area_id", sortModel[0]?.sort ?? "desc");
                setCurrentPage((prev) => Math.max(prev - 1, 0)); // 0未満にならないように
            }
        } catch (error) {
            // エラーハンドリング
            console.error(error);
            alert('データ取得に失敗しました');
        }
    
        // その他の追加処理
        console.log(`ページが${newPage + 1}に切り替わりました`);
    };

    return (
        <Box>
            <Grid container>
                <Grid item xs={12} sx={{ height: "48px" }} />
            </Grid>
            <Grid container direction={"row"} sx={{ position: "fixed" }}>
                <Grid
                    item
                    sx={{
                        width: props.width + 56,
                        height: props.height,
                        overflow: "scroll",
                    }}
                >
                    <Box sx={{ position: "relative", bgcolor: "#F8FAF8", margin: "20px", }}>
                        <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                            <Grid item xs={12}>
                                {/** アコーディオン */}
                                <AccordionMenu props={{
                                    handleMethod: handleMethod,
                                    userType: userType,
                                    disabledSearch: disabledSearch,
                                    conversionCreateDate: conversionCreateDate,
                                    statusList: statusList,
                                    picTypeList: picTypeList,
                                    requestTaskList: requestTaskList,
                                    picNameList: picNameList,
                                    departmentList: departmentList,
                                    districtList: districtList,
                                    planAreaIdList: planAreaIdList,
                                    planAreaRfcList: planAreaRfcList,
                                    departmentName: departmentName,
                                    districtName: districtName,
                                    statusValueList: statusValueList,
                                    picTypeValueList: picTypeValueList,
                                    taskValueList: taskValueList,
                                    picNameValueList: picNameValueList,
                                    districtValueList: districtValueList,
                                    departmentValueList: departmentValueList,
                                    rfcValueList: rfcValueList,
                                    planAreaId: planAreaId,
                                    planAreaName: planAreaName,
                                }} />
                            </Grid>
                            {/* テーブル部分 */}
                            <Grid item xs={12}>
                                <Box sx={{ width: "100%", height: Math.floor(props.height / 2) + 160 }}>
                                    <DataGrid
                                        columns={columns.filter((col) =>
                                            visibleColumns.includes(col.field)
                                        )}
                                        rows={rows}
                                        sx={styles.dataGrid}
                                        density="compact"
                                        onRowSelectionModelChange={handleTableModalOpen}
                                        slots={{
                                            toolbar: costomToolBar,
                                            footer: showFooter
                                                ? () => (
                                                    <CustomFooter
                                                        rowCount={total}
                                                        page={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handlePageChange}
                                                        dataGridLoading={dataGridLoading}
                                                    />
                                                )
                                              : () => null // ← 何も表示しない
                                        }}
                                        loading={dataGridLoading}
                                        getRowClassName={(
                                            params: GridRowParams
                                        ) => {
                                            if (
                                                params.row.elapsedFlag === "1"
                                            ) {
                                                return "active-elapsed-row";
                                            }
                                            return "";
                                        }}
                                        sortModel={sortModel}
                                        onSortModelChange={(newSortModel): void => {
                                            if (newSortModel.length === 0) {
                                                // ソート条件がない場合の処理
                                                handleSerch("first", "plan_area_id", "desc");
                                                setSortModel([]);
                                            } else {
                                                // ソート条件がある場合の処理
                                                handleSerch("first", newSortModel[0].field, newSortModel[0].sort ?? "desc");
                                                setSortModel(newSortModel);
                                            }
                                        }}
                                        sortingMode="server"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            {/* モーダル部分(調査書枝選択画面) */}
            <ResearchBranchModal
                props={{
                    modalOpen: researchBranchOpen,
                    setModalOpen: setResearchBranchOpen,
                    planAreaId: selectPlanAreaId,
                    obj: selectDataObj,
                }}
            />

            {/* モーダル部分(メール作成画面) */}
            <MailCreateModal
                props={{
                    modalOpen: mailModalOpen,
                    setModalOpen: setMailModalOpen,
                    obj: selectMailObj,
                    user: user.userData,
                }}
            />

            {/* モーダル部分(テーブルレコード) */}
            <Dialog
                open={tableModalOpen}
                onClose={handleTableModalClose}
            >
                <DialogTitle>選択してください</DialogTitle>
                <List>
                    <ListItem>
                        <ModalButton
                            onClick={handleResearchBranchOpen}
                        >
                            調査書
                        </ModalButton>
                    </ListItem>
                    <ListItem>
                        <ModalButton
                            onClick={() => {
                                handlePageMove("/RequestComment");
                            }}
                            disabled={
                                userType === LOCAL_CONSTANT.USER_TYPE.RM ||
                                userType === LOCAL_CONSTANT.USER_TYPE.RFC ||
                                userType === LOCAL_CONSTANT.USER_TYPE.GM
                            }
                        >
                            依頼/コメント
                        </ModalButton>
                    </ListItem>
                    <ListItem>
                        <ModalButton
                            onClick={handleMailModalOpen}
                            disabled={
                                userType === LOCAL_CONSTANT.USER_TYPE.RM ||
                                userType === LOCAL_CONSTANT.USER_TYPE.RFC ||
                                userType === LOCAL_CONSTANT.USER_TYPE.OTHER ||
                                userType === LOCAL_CONSTANT.USER_TYPE.GM
                            }
                        >
                            メール送信
                        </ModalButton>
                    </ListItem>
                </List>
            </Dialog>

            {/* モーダル部分(GIS取込) */}
            <GisImportModal
                props={{
                    open: gisImportModalOpen,
                    handleModal: closeGisImportModal,
                }}
            />
        </Box >
    );
};

export default SecondaryListItems;
